<template>
	<div class="col-12">
		<ModalInstructions v-if="openInstruction" @close="openInstruction = false"></ModalInstructions>		
		<div class="card card-outline card-info">
			<div class="card-header">
				<h3 class="card-title">Llenado de evaluación</h3>
			</div>
			<div class="card-body w-full" v-if="evaluation && user">
				<FillEvaluation :evaluation="evaluation || []" :user="user || []" v-if="!filled"></FillEvaluation>  
				<span v-else> Evaluación completada.</span>                   				
			</div>

			<div class="card-body w-full" v-else>
				<span > Hubo un problema, por favor regrese al menu principal.</span>                   				
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

import request from '../../services/request'
import ModalInstructions from '../../component/evaluations/ModalInstructions.vue';
import FillEvaluation from '../../component/evaluations/FillEvaluation.vue';

export default {
	props: {
		evaluation: {
		type: [Object, Array],
		required: true,
		},
		user: {
		type: [Object, Array],
		default: () => [] // Define un valor por defecto
		},
	},
	
	name: "evaluation-fill",
	components: {
		FillEvaluation,
		ModalInstructions
	},
	data() {
		return {
			filled: false,
			openInstruction: true,
		}
	},
	async mounted() {
		this.setHeaderTitle('Encuesta');
		await this.evaluationsRequest()
	},
	created() {
		Event.$on("event-load-profiles", () => {
			this.list();
		});
	},
	methods: {
        async evaluationsRequest() {
			let service = request;
			let _endpoint = '/evaluations';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					this.evaluations = data;
				}
				this.filledAutoEvaluation()
			} catch (error) {
				console.log(error);
			}
		},
		async filledAutoEvaluation() {
			let service = request;
			let _endpoint = '/evaluations/mine';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					if (this.evaluation) {
						if (this.evaluation.type &&  this.evaluation.type == 'autoevaluation') {
								this.filled = data;							
						}
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
		})
	}
}
</script>

<style scoped>
.card-body{
	width: 100%;
	max-height: 75vh;
    overflow-y: overlay;
}
/* General */
* {
  scrollbar-color: #1d4745 #ffffff; /* Color del thumb y del fondo */
  scrollbar-width: thin; /* Ancho del scroll reducido */
}

/* Webkit */
::-webkit-scrollbar {
  width: 12px; /* Ancho del scroll vertical */
  height: 12px; /* Altura del scroll horizontal */
}

::-webkit-scrollbar-track {
  background: #ffffff; /* Fondo blanco del scroll */
  border-radius: 10px; /* Bordes redondeados del track */
  margin: 2px; /* Espaciado para evitar que el thumb toque los bordes */
}

::-webkit-scrollbar-thumb {
  background: #1d4745; /* Color del thumb */
  border-radius: 10px; /* Bordes redondeados del thumb */
  border: 2px solid #ffffff; /* Espaciado entre el thumb y el track */
}

::-webkit-scrollbar-thumb:hover {
  background: #14534f; /* Color más oscuro al pasar el mouse */
}




</style>
